import React, { useState, useEffect } from "react";
import "../pages/Home.css";

const Home = () => {

  const images = [
    "/images/slide1.jpeg",
    "/images/slide2.jpeg",
    "/images/slide3.jpeg"
  ];

  const [index, setIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prev) => (prev + 1) % images.length);
    }, 3000);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="home-container">

      {/* ===== Marquee ===== */}

      


      {/* ===== Image Slider ===== */}

      <div className="slider">

        <img src={images[index]} alt="slider" />

        <div className="slider-text">
          <h1>ग्रामपंचायत सायकी</h1>
          <p>तालुका उमरेड | जिल्हा नागपूर</p>
        </div>

      </div>


      {/* ===== Leaders Section ===== */}

      <section className="leaders">

        <div className="leader-card">

          <img src="/images/sarpanch.jpeg" alt="sarpanch" />
          <h3>श्री. प्रशांत शेषराव व्यापारी</h3>
          <p>सरपंच</p>

        </div>

        <div className="leader-card">

          <img src="/images/upsarpanch.jpeg" alt="upsarpanch" />
          <h3>सौ. करिश्मा होमेश्वर वाकडे</h3>
          <p>उपसरपंच</p>

        </div>

        <div className="leader-card">

          <img src="/images/sachiv.jpeg" alt="gramvikas" />
          <h3>सौ. वर्षा खोडे</h3>
          <p>ग्रामपंचायत अधिकारी</p>
          

        </div>

      </section>


      {/* ===== Committee Table ===== */}

      <section className="committee">

        <h2>कार्यकारी मंडळ ग्रामपंचायत सायकी</h2>

        <div className="table-container">

          <table>

            <thead>
              <tr>
                <th>अ.क्र.</th>
                <th>नाव</th>
                <th>पद</th>
              </tr>
            </thead>

            <tbody>

              {[
                
                ["1","श्री चिरकुट गोमा नेवारे","सदस्य"],
                ["2","श्री अभिषेक अशोक देवगडे","सदस्य"],
                ["3","श्री चंद्रभान तेलरांधे","सदस्य"],
                ["4","सौ शशिकला उमेश गणवीर","सदस्य"],
                ["5","श्रीमती इंदू सुरेश सहारे","सदस्य"],
                ["6","सौ कविता राऊत","सदस्य"],
               
              ].map((row, index) => (

                <tr key={index}>
                  {row.map((cell, i) => (
                    <td key={i}>{cell}</td>
                  ))}
                </tr>

              ))}

            </tbody>

          </table>

        </div>

      </section>

    </div>
  );
};

export default Home;